import { ReactNode, useCallback, useState } from 'react';

import { AnalyticsContext, AnalyticsGetData } from '@/app/analytics/context';
import type { AnalyticsData } from '@/app/mutations/AnalyticsMutation/fetchAnalytics';


export default function withAnalytics<T extends object>(
  Component: (props: T) => ReactNode,
) {
  return function ConnectedComponent(props: T) {
    const [data, setData] = useState<AnalyticsData>({});

    const track = useCallback((getData: AnalyticsGetData) => {
      setData(previous => ({ ...previous, ...getData(previous) }));
    }, []);

    return (
      <AnalyticsContext.Provider value={{ data, track }}>
        <Component {...props} />
      </AnalyticsContext.Provider>
    );
  };
}
